<template>
	<div>
        <div class="modal-header flex items-center justify-between cursor-move">
            <h1 class="flex-1 text-2xl">Manage Project Comps</h1>
            <div @click="hideModal">
                <inline-svg name="close" classes="w-5 h-5 text-white fill-current cursor-pointer"></inline-svg>
            </div>
        </div>
        <div class="w-full">
            <building-cards
                small-header
                is-for-project
                view="table"
                @add-building-to-project="addProjectComp($event)"
                @remove-building-from-project="removeProjectComp($event)">
            </building-cards>
        </div>
	</div>
</template>

<script>
	import { mapState } from 'vuex';

	export default {
		props: {
			projectId: {
				type: Number,
				required: true
			},

			compData: {
				type: [Array, Object],
				required: true
			},
		},

		data() {
			return {

			}
		},

        mounted() {
            this.projectComps.all = this.compData;
            this.projectComps.filtered = this.compData;
        },

        computed: {
            ...mapState(['projectComps']),
        },

        methods: {
        	addProjectComp(building) {
                axios.post("/projects/" + this.projectId + "/comps", {
                	'building_id': building.id
                }).then((response) => {
					this.updateComps(response.data.comps);
                	
					this.$notify({
						type: 'success',
						title: 'Success',
						text: response.data.message
					});
				}).catch((error) => {
                    this.$notify({
                        type: 'error',
                        title: 'Error',
                        text: error.response.data.message
                    });
                });
        	},

        	removeProjectComp(compId) {
                axios.delete("/projects/" + this.projectId + "/comps/" + compId).then((response) => {
                	this.updateComps(response.data.comps);

					this.$notify({
						type: 'success',
						title: 'Success',
						text: response.data.message
					});                    
                }).catch((error) => {
                    this.$notify({
                        type: 'error',
                        title: 'Error',
                        text: error.response.data.message
                    });
                });
			},

			updateComps(comps) {
                this.projectComps.all = comps;
            	this.projectComps.filtered = comps;
			}
        }
	}
</script>